import { makeEmptyPlan } from '@components/PatientPlans';
import type { PatientPlanValue } from '@components/PatientPlans';

/**
 * Names the wizard pre-seeds the plan list with. The admin renames, edits or
 * removes them freely — creating an org with no plans at all is valid.
 */
const DEFAULT_PLAN_NAMES = ['Lite', 'Pro', 'Elite', 'Ultimate'];

export function defaultPatientPlans(): PatientPlanValue[] {
  return DEFAULT_PLAN_NAMES.map((name) => makeEmptyPlan(name));
}
